import styles from "./Footer.module.css";
import { Site } from "@/types/sites";
import { CmsImage } from "../CmsImage";
import useResizeListener from "../../../hooks/useResizeListener";

export const Footer = ({ site }: { site: Site | null }) => {
    const setFooterPadding = () => {
        const footer = document?.getElementById("footerContainer");
        if (footer) {
            const ribbonHeight = document?.getElementById(
                "terms-and-conditions-ribbon"
            )?.offsetHeight;

            if (ribbonHeight) {
                document
                    ?.querySelector<HTMLElement>(":root")
                    ?.style?.setProperty(
                        "--ts-and-cs-ribbon-height",
                        `${ribbonHeight}px`
                    );
            }
        }
    };

    useResizeListener(setFooterPadding);
    const regionCodeParam = site?.attributes?.policyPageRegionCode
        ? `?region=${site?.attributes?.policyPageRegionCode}`
        : "";

    const termsAndConditionsLink = `/policy/terms-and-conditions${regionCodeParam}`;
    const privacyPolicyLink = `/policy/privacy${regionCodeParam}`;
    const unsubscribeLink = `/policy/unsubscribe${regionCodeParam}`;

    return (
        <footer id="footer" className={styles.footer}>
            <div id="footerContainer" className={styles.footerContainer}>
                <div className={styles.footerBranding}>
                    <CmsImage
                        cmsMedia={site?.attributes?.logo || null}
                        desiredHeight={75}
                        defaultAlt={site?.attributes?.name}
                    />
                </div>
                <div className={styles.footerBody}>
                    <div className={styles.linkTitle}>Helpful Links</div>
                    <div className={styles.footerLinks}>
                        <a
                            className={styles.linkAnchor}
                            href={termsAndConditionsLink}
                            rel="noreferrer"
                            target="_blank"
                        >
                            Terms &amp; Conditions
                        </a>
                        <a
                            className={styles.linkAnchor}
                            href={privacyPolicyLink}
                            rel="noreferrer"
                            target="_blank"
                        >
                            Privacy Policy
                        </a>
                        <a
                            className={styles.linkAnchor}
                            href={unsubscribeLink}
                            rel="noreferrer"
                            target="_blank"
                        >
                            Unsubscribe
                        </a>
                    </div>
                    <div className={styles.compliance}>
                        {/* If this contains an image then on localhost it throws 404 but works fine on the server */}
                        <div
                            className={styles.complianceText}
                            dangerouslySetInnerHTML={{
                                __html:
                                    site?.attributes?.sanitisedFooterText || "",
                            }}
                        ></div>
                    </div>
                </div>
                {(site?.attributes?.compliances?.data?.length || 0) > 0 && (
                    <div className={styles.complianceLogos}>
                        {site?.attributes?.compliances?.data?.map(
                            (compliance) => (
                                <a
                                    key={compliance.id}
                                    aria-label={`Compliance link ${compliance.id}`}
                                    className={styles.complianceLogoContainer}
                                    href={compliance.attributes.link}
                                    rel={compliance.attributes.rel || ""}
                                    target={
                                        compliance.attributes.target || "_blank"
                                    }
                                >
                                    <CmsImage
                                        cmsMedia={compliance.attributes.logo}
                                        desiredHeight={50}
                                        maxWidth={300}
                                    />
                                </a>
                            )
                        )}
                    </div>
                )}
                <div className={styles.copyright}>
                    &copy;&nbsp;{site?.attributes?.name || ""}
                </div>
            </div>
        </footer>
    );
};
